/**
 * Ensure defaults and formatting for Stores and Plugins
 */

'use strict';

exports.__esModule = true;
exports['default'] = defaults;

var _typeChecks = require('./type-checks');

function defaults(config) {
  return _typeChecks.isFunction(config) ? { register: config } : config;
}

module.exports = exports['default'];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9kZWZhdWx0cy5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7O3FCQU13QixRQUFROzswQkFGTCxlQUFlOztBQUUzQixTQUFTLFFBQVEsQ0FBRSxNQUFNLEVBQUU7QUFDeEMsU0FBTyx1QkFBVyxNQUFNLENBQUMsR0FBRyxFQUFFLFFBQVEsRUFBRSxNQUFNLEVBQUUsR0FBRyxNQUFNLENBQUE7Q0FDMUQiLCJmaWxlIjoic3JjL2RlZmF1bHRzLmpzIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBFbnN1cmUgZGVmYXVsdHMgYW5kIGZvcm1hdHRpbmcgZm9yIFN0b3JlcyBhbmQgUGx1Z2luc1xuICovXG5cbmltcG9ydCB7IGlzRnVuY3Rpb24gfSBmcm9tICcuL3R5cGUtY2hlY2tzJ1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBkZWZhdWx0cyAoY29uZmlnKSB7XG4gIHJldHVybiBpc0Z1bmN0aW9uKGNvbmZpZykgPyB7IHJlZ2lzdGVyOiBjb25maWcgfSA6IGNvbmZpZ1xufVxuIl19




/*****************
 ** WEBPACK FOOTER
 ** ./~/microcosm/defaults.js
 ** module id = 195
 ** module chunks = 0
 **/